import * as log from 'loglevel'

function getOptions(ctx) {
  return {
    headers: {
      Authorization: ctx.rootState.user.token
    }
  }
}

const actions = {
  graphOpenEvent(ctx, params) {
    let options = {}
    options.options = getOptions(ctx)
    try {
      options.payload = {
        eventType: 'open_graph',
        chunkId: params.chunkId,
        graphId: params.graphId
      }
      return ctx.rootState.api.postEvent(options)
    } catch (err) {
      log.error(err)
    }
  },
  graphSaveEvent(ctx, params) {
    let options = {}
    options.options = getOptions(ctx)
    try {
      options.payload = {
        eventType: 'save_graph',
        chunkId: params.chunkId,
        graphId: params.graphId
      }
      return ctx.rootState.api.postEvent(options)
    } catch (err) {
      log.error(err)
    }
  }
}

export default {
  actions
}
